"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContextSlideShow = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ArrowLeft = _interopRequireDefault(require("@material-ui/icons/ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("@material-ui/icons/ArrowRight"));

var _CropRotate = _interopRequireDefault(require("@material-ui/icons/CropRotate"));

var _Image = _interopRequireDefault(require("@material-ui/icons/Image"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _authorAvatar = _interopRequireDefault(require("../controls/author-avatar"));

var _compositionsButtonWithIcon = _interopRequireDefault(require("@eig-builder/compositions-button-with-icon"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _mobileDetectionHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/mobile-detection-helper"));

var _imageLibraryHelper = require("../helpers/image-library-helper");

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _hooks = require("../hooks");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;

var SlideShowMain = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  position: absolute;\n  bottom: 100px;\n  left: 0;\n  right: 0;\n  top: 0;\n"])));

var BottomNavigationBar = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  position: absolute;\n  bottom: 10px;\n  left: 0;\n  right: 0;\n"])));

var ImageNavigationBox = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  padding-left: 10px;\n  padding-right: 10px;\n  width: 100%;\n"])));

var ImageNavigationScrollBox = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  overflow-x: scroll;\n  overflow-y: hidden;\n  width: 100%;\n  white-space: nowrap\n"])));

var ImageSmallBox = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  background: url(", ");\n  background-size: cover;\n  width: 60px;\n  height: 60px;\n  margin-right:5px;\n  display: inline-block;\n  &:hover {\n    border: 2px solid #0092fd;\n    cursor: pointer;\n  }\n  ", "\n"])), function (props) {
  return props.image;
}, function (props) {
  return props.active && (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    border: 2px solid #0092fd;\n  "])));
});

var ImageModalBox = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  background: url(", ");\n  background-size: contain;\n  width: 100%;\n  height: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n  position: relative;\n"])), function (props) {
  return props.image;
});

var StyledIconNavButton = (0, _styledComponents["default"])(_IconButton["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute !important;\n  top: 50%;\n  z-index: 10;\n  background-color: #eee !important;\n  margin-top: -20px;\n"])));
var NavigationLeft = (0, _styledComponents["default"])(StyledIconNavButton)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  left: 30px;\n"])));
var NavigationRight = (0, _styledComponents["default"])(StyledIconNavButton)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  right: 30px;\n"])));

var ActionButtonBox = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  margin-top: 20px;\n\n  ", "\n\n  button:first-child {\n    margin-right: 5px;\n  }\n"])), function (props) {
  return props.mobile && (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n  "])));
});

var CopyrightTextBox = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  text-align: left;\n  position: absolute;\n  bottom: 10px;\n  font-size: 14px;\n  padding-right: 10px;\n\n  a {\n    font-size: 14px;\n  }\n"])));

var ImageWrapperBox = _styledComponents["default"].div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: 10px;\n  margin-left: 10px;\n  position: relative;\n"])));

var SlideShowSidebar = _styledComponents["default"].div(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 10px;\n  position: relative;\n  background: #f6f6f6;\n"])));

var SlideShowContainer = _styledComponents["default"].div(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2["default"])(["\n  display: grid;\n  grid-template-rows: 1fr 110px;\n  height: calc(80vh - 70px);\n  position: relative;\n"])));

var SlideShowMainWrapper = _styledComponents["default"].div(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2["default"])(["\n  height:100%;\n  display: grid;\n  grid-template-columns: 1fr 250px;\n\n  ", "\n"])), function (props) {
  return props.mobile && (0, _styledComponents.css)(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2["default"])(["\n    grid-template-columns: 1fr;\n  "])));
});

var DimensionsBox = _styledComponents["default"].div(_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: 20px;\n  font-size: 14px;\n  display: grid;\n  grid-template-columns: auto 1fr;\n"])));

var DimensionsText = _styledComponents["default"].div(_templateObject20 || (_templateObject20 = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: 400;\n"])));

var StyledButtonWithIcon = (0, _styledComponents["default"])(_compositionsButtonWithIcon["default"])(_templateObject21 || (_templateObject21 = (0, _taggedTemplateLiteral2["default"])(["\n  .mr-2 {\n    margin-right: 5px !important;\n  }\n"])));

var StyledViewMore = _styledComponents["default"].small(_templateObject22 || (_templateObject22 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  i {\n    font-size: 14px !important;\n  }\n"])));

var SlideShow = function SlideShow(_ref) {
  var onSelectionChanged = _ref.onSelectionChanged,
      onSelect = _ref.onSelect,
      meta = _ref.meta,
      setSelectedImage = _ref.setSelectedImage,
      setMetaImages = _ref.setMetaImages,
      selectedImage = _ref.selectedImage,
      images = _ref.metaImages;

  var _useActiveView = (0, _hooks.useActiveView)('slideshow'),
      active = _useActiveView.active,
      currentView = _useActiveView.currentView;

  var scrollBoxRef = _react["default"].createRef();

  var selectedImageLocallyIndex = selectedImage;

  var setScrollPosition = function setScrollPosition() {
    if (scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : scrollBoxRef.current) {
      var _scrollBoxRef$current;

      var boxOffset = selectedImage === 0 ? 0 : 65 * selectedImage - 30;
      var boxWidthClient = scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current = scrollBoxRef.current) === null || _scrollBoxRef$current === void 0 ? void 0 : _scrollBoxRef$current.clientWidth;
      var boxWidthHalf = boxWidthClient / 2;
      var offsetMinusBoxHalf = boxOffset - boxWidthHalf;

      if (boxOffset > boxWidthHalf) {
        scrollBoxRef.current.scrollLeft = offsetMinusBoxHalf;
      }

      if (boxOffset < boxWidthHalf) {
        scrollBoxRef.current.scrollLeft = 0;
      }
    }
  };

  _react["default"].useEffect(function () {
    if (active) {
      setScrollPosition();
    }
  }, [active]);

  _react["default"].useEffect(function () {
    setScrollPosition();
  }, [selectedImage]);

  var selectImage = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var selectedImage, downloadLocation, response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedImage = images[selectedImageLocallyIndex];
              downloadLocation = selectedImage.downloadLocation;
              _context.next = 4;
              return (0, _imageLibraryHelper.unsplashCallBack)({
                downloadLocation: downloadLocation
              });

            case 4:
              response = _context.sent;

              if (response) {
                onSelect(selectedImage);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function selectImage() {
      return _ref2.apply(this, arguments);
    };
  }();

  if (!active) {
    return null;
  }

  var _ref3 = images[selectedImageLocallyIndex] || {},
      thumbnail = _ref3.thumbnail,
      user = _ref3.user,
      originalHeight = _ref3.originalHeight,
      originalWidth = _ref3.originalWidth,
      original = _ref3.original;

  var goToEditImage = function goToEditImage() {
    var imageData = images[selectedImageLocallyIndex];
    onSelectionChanged(imageData, 'slideshow');
  };

  var showNavLeft = selectedImageLocallyIndex !== 0;
  var showNavRight = selectedImageLocallyIndex !== images.length - 1;
  return /*#__PURE__*/_react["default"].createElement(SlideShowContainer, null, /*#__PURE__*/_react["default"].createElement(SlideShowMain, null, /*#__PURE__*/_react["default"].createElement(SlideShowMainWrapper, {
    mobile: (0, _mobileDetectionHelper["default"])()
  }, /*#__PURE__*/_react["default"].createElement(ImageWrapperBox, null, /*#__PURE__*/_react["default"].createElement(ImageModalBox, {
    image: original || thumbnail
  }), showNavLeft && /*#__PURE__*/_react["default"].createElement(NavigationLeft, {
    onClick: function onClick() {
      return selectedImageLocallyIndex !== 0 && setSelectedImage(selectedImageLocallyIndex - 1);
    },
    dataElementLabel: "image-selector--nav--go-back",
    dataElementLocation: _taggingHelper.DataElementLocations.NAV,
    dataElementId: "image-selector--nav--go-back"
  }, /*#__PURE__*/_react["default"].createElement(_ArrowLeft["default"], null)), showNavRight && /*#__PURE__*/_react["default"].createElement(NavigationRight, {
    onClick: function onClick() {
      return selectedImageLocallyIndex - 1 !== images.length && setSelectedImage(selectedImageLocallyIndex + 1);
    },
    dataElementLabel: "image-selector--nav--go-next",
    dataElementLocation: _taggingHelper.DataElementLocations.NAV,
    dataElementId: "image-selector--nav--go-next"
  }, /*#__PURE__*/_react["default"].createElement(_ArrowRight["default"], null))), !(0, _mobileDetectionHelper["default"])() && /*#__PURE__*/_react["default"].createElement(SlideShowSidebar, null, /*#__PURE__*/_react["default"].createElement(_authorAvatar["default"], {
    user: user,
    viewMore: true,
    showTitle: false,
    size: "large",
    nameDisplay: function nameDisplay(_ref4) {
      var name = _ref4.name;
      return name;
    },
    userNameDisplay: function userNameDisplay(_ref5) {
      var username = _ref5.username;
      return /*#__PURE__*/_react["default"].createElement(StyledViewMore, null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "search"
      }), /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
        message: "imagepicker.moreFromUser"
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(DimensionsBox, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "h5"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.dimensions"
  }), ":"), /*#__PURE__*/_react["default"].createElement(DimensionsText, null, "\xA0", originalWidth, " x ", originalHeight)), /*#__PURE__*/_react["default"].createElement(ActionButtonBox, null, /*#__PURE__*/_react["default"].createElement(StyledButtonWithIcon, {
    color: "secondary",
    onClick: goToEditImage,
    tag: "edit-image-from-library",
    variant: "outlined",
    labelPosition: "after",
    icon: /*#__PURE__*/_react["default"].createElement(_CropRotate["default"], null),
    dataElementLabel: "image-selector--slideshow--edit",
    dataElementLocation: _taggingHelper.DataElementLocations.NAV,
    dataElementId: "image-selector--slideshow--edit"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImage"
  })), /*#__PURE__*/_react["default"].createElement(StyledButtonWithIcon, {
    color: "primary",
    onClick: selectImage,
    tag: "save-editted-image-from-library",
    labelPosition: "after",
    icon: /*#__PURE__*/_react["default"].createElement(_Image["default"], null),
    dataElementLabel: "image-selector--slideshow--use",
    dataElementLocation: _taggingHelper.DataElementLocations.NAV,
    dataElementId: "image-selector--slideshow--use"
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.use"
  }))), /*#__PURE__*/_react["default"].createElement(CopyrightTextBox, null, (currentView === 'free-images' || currentView === 'slideshow') && /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.copyrightText",
    values: {
      terms: /*#__PURE__*/_react["default"].createElement("a", {
        key: "unsplash-link",
        href: "https://unsplash.com/terms",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "terms")
    }
  })))), (0, _mobileDetectionHelper["default"])() && /*#__PURE__*/_react["default"].createElement(ActionButtonBox, {
    mobile: true
  }, /*#__PURE__*/_react["default"].createElement(StyledButtonWithIcon, {
    color: "secondary",
    onClick: goToEditImage,
    tag: "save-editted-image-from-library",
    variant: "outlined",
    labelPosition: "after",
    icon: /*#__PURE__*/_react["default"].createElement(_CropRotate["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.editImage"
  })), /*#__PURE__*/_react["default"].createElement(StyledButtonWithIcon, {
    color: "primary",
    onClick: function onClick() {
      return onSelect(images[selectedImageLocallyIndex]);
    },
    tag: "save-editted-image-from-library",
    labelPosition: "after",
    icon: /*#__PURE__*/_react["default"].createElement(_Image["default"], null)
  }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.use"
  }))))), /*#__PURE__*/_react["default"].createElement(BottomNavigationBar, null, /*#__PURE__*/_react["default"].createElement(ImageNavigationBox, null, /*#__PURE__*/_react["default"].createElement(ImageNavigationScrollBox, {
    ref: scrollBoxRef
  }, images.map(function (image, index) {
    return /*#__PURE__*/_react["default"].createElement(ImageSmallBox, {
      key: index,
      image: image.thumbnail,
      active: index === selectedImageLocallyIndex,
      onClick: function onClick() {
        return setSelectedImage(index);
      }
    });
  })))));
};

SlideShow.propTypes = {
  setSelectedImage: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  onSelectionChanged: _propTypes["default"].func,
  meta: _propTypes["default"].object,
  selectedImage: _propTypes["default"].number,
  metaImages: _propTypes["default"].array,
  setMetaImages: _propTypes["default"].func
};
var WithContextSlideShow = (0, _withContext["default"])(SlideShow);
exports.WithContextSlideShow = WithContextSlideShow;